import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import moment from 'moment-timezone/moment-timezone';
import * as _ from 'lodash';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  // Migrated from AngularJS https://raw.githubusercontent.com/Ins87/angular-date-interceptor/master/src/angular-date-interceptor.js
  // milliseconds = /^\d{13}?/;
  iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d+)|Z)?$/;
  onyDate = /^\d{4}-\d\d-\d\d$/;

  constructor(
    private julContextService: JulContextLibService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let contextFromRequest = this.julContextService.JulContext;
    let timezone = null;
    const request = _.cloneDeep(req) as any;

    if (localStorage.getItem('context-timezone') && contextFromRequest){
      let find = JSON.parse(localStorage.getItem('context-timezone')).find(x=> x.locode == contextFromRequest || x.locode.includes(contextFromRequest));
      if (find && find.timezone){
        timezone = find.timezone;
      }
    }

    if (timezone && req && req.body){
      const body = this.convertToDateWithoutOffset(req.body, timezone);
      request.body = body;
    }

    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const body = event.body;
        this.convertToDate(body, timezone);
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
        }
      }
    });
  }


  convertToDate(body, contextTimeZone?) {

    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isIso8601(value) && new Date(value).toDateString()!=='Invalid Date') {

        if (this.onyDate.test(value)){

            body[key] = this.removeOffset(value);

        } else {
          if (contextTimeZone) {

            // TRANSFORM STRING TO DATE
            let date = moment(value);

            // CHANGE TIMEZONE (TZ) TO THE contextTimeZone
            date = date.tz(contextTimeZone).format('YYYY-MM-DDTHH:mm:ss');

            body[key] = new Date(date);
          }
          else
            body[key] = new Date(value);
        }
      } else if (typeof value === 'object') {
        this.convertToDate(value, contextTimeZone);
      }
    }
  }


  convertToDateWithoutOffset(body, contextTimeZone?) {

    let changedBody = _.cloneDeep(body);

    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (value instanceof Date) {

        // TRANSFORM Date TO MomentDate
        let momentDate = moment(this.offsetToUtc(value).toISOString())

        // CHANGE TIMEZONE (TZ) TO THE contextTimeZone
        let date = momentDate.tz(contextTimeZone);

        let offset = date.utcOffset();

        date = new Date(date.add(-(offset), 'minutes').toISOString()).toISOString();

        changedBody[key] = date;

      } else if (typeof value === 'object') {
        changedBody[key] = this.convertToDateWithoutOffset(value, contextTimeZone);
      }
    }

    return changedBody;
  }

  removeOffset(value){
    let offsetDates;
    let dateWithoutOffset = new Date(value);
    offsetDates = dateWithoutOffset.getTimezoneOffset() / 60;

    if (offsetDates){
      dateWithoutOffset.setHours(dateWithoutOffset.getHours() + offsetDates);
    }

    return dateWithoutOffset;
  }

  offsetToUtc(value){
    let offsetDates;
    let dateWithoutOffset = new Date(value);
    offsetDates = dateWithoutOffset.getTimezoneOffset() / 60;

    if (offsetDates){
      dateWithoutOffset.setHours(dateWithoutOffset.getHours() - offsetDates);
    }

    return dateWithoutOffset;
  }

  isIso8601(value) {

    if (value === null || value === undefined) {
      return false;
    }

    return this.iso8601.test(value) || this.onyDate.test(value);
  }
}
